import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { action, computed, makeObservable } from "mobx";
import { AbstractPost, ClientModel } from "@devowl-wp/utils";
import { request } from "../utils/request.js";
class BannerLinkModel extends AbstractPost {
    get rootStore() {
        return this.collection.store.rootStore;
    }
    constructor(collection, data = {}){
        super(collection, data);
        makeObservable(this);
    }
    setOrder(order) {
        this.data.menu_order = order;
    }
    setLabel(label) {
        this.data.title.raw = label;
    }
    setStatus(status) {
        this.data.status = status;
    }
    setMeta(meta) {
        this.data.meta = meta;
    }
    transformDataForPatch() {
        const data = super.transformDataForPatch();
        return {
            title: data.title,
            content: "",
            status: data.status,
            meta: data.meta,
            menu_order: data.menu_order,
            slug: data.title
        };
    }
}
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], BannerLinkModel.prototype, "rootStore", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Number
    ]),
    _ts_metadata("design:returntype", void 0)
], BannerLinkModel.prototype, "setOrder", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String
    ]),
    _ts_metadata("design:returntype", void 0)
], BannerLinkModel.prototype, "setLabel", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof PostStatus === "undefined" ? Object : PostStatus
    ]),
    _ts_metadata("design:returntype", void 0)
], BannerLinkModel.prototype, "setStatus", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object
    ]),
    _ts_metadata("design:returntype", void 0)
], BannerLinkModel.prototype, "setMeta", null);
BannerLinkModel = _ts_decorate([
    ClientModel.annotate({
        keyId: "id",
        namespace: "wp/v2",
        request,
        create: {
            path: "/rcb-banner-link"
        },
        patch: {
            path: "/rcb-banner-link/:id"
        },
        delete: {
            path: "/rcb-banner-link/:id"
        }
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object,
        typeof Partial === "undefined" ? Object : Partial
    ])
], BannerLinkModel);
export { BannerLinkModel };
